import { create } from 'zustand';

const useVersionsStore = create((set) => ({
    versions: {
        bomo: '',
        back: '',
        customPay: ''
    },
    setVersions: (versions) => set(() => ({ versions }))
}));

export default useVersionsStore;